import { render } from "./ShopBasketTotal.vue?vue&type=template&id=6bac60dc"
import script from "./ShopBasketTotal.vue?vue&type=script&lang=js"
export * from "./ShopBasketTotal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__